export const guestCreditCardLinkConstants = {
    GET_GUEST_CREDIT_CARD_PAYMENT_URL_REQUEST: 'GET_GUEST_CREDIT_CARD_PAYMENT_URL_REQUEST',
    GET_GUEST_CREDIT_CARD_PAYMENT_URL_SUCCESS: 'GET_GUEST_CREDIT_CARD_PAYMENT_URL_SUCCESS',
    GET_GUEST_CREDIT_CARD_PAYMENT_URL_FAILURE: 'GET_GUEST_CREDIT_CARD_PAYMENT_URL_FAILURE'
}